module.exports = __webpack_public_path__ + "files/480fd2c2db4c44867838743a42bd47b8.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-3.png
// module id = 1622
// module chunks = 60